import { FleetTime } from '@src/main/modules/ibdp/domain/fleet-time.interface';

export interface FleetTimeOption {
  value: string;
  label: string;
  raw: FleetTime;
}

export const mapFleetToOption = (fleet: FleetTime): FleetTimeOption => ({
  value: `${fleet.fleet}-${fleet.subFleet}`,
  label: `${fleet.fleet} - ${fleet.subFleet}`,
  raw: fleet,
});
